'use strict';

var _require = require('lodash'),
    chain = _require.chain,
    includes = _require.includes,
    repeat = _require.repeat,
    truncate = _require.truncate;

var _require2 = require('./charFunk'),
    isLetterOrDigit = _require2.isLetterOrDigit;

var ALLOWED_CHARACTERS = ['_', '~', '-'];
var MIN_SLUG_LENGTH = 5;

var slugifyUnicode = function slugifyUnicode(string, allowedCharacters) {
  var whitelistedChars = ALLOWED_CHARACTERS.concat(allowedCharacters.map(truncateWhitelistedCharacter));
  return chain(string).toString().map(function (char) {
    return isLetterOrDigit(char) || includes(whitelistedChars, char) ? char : '-';
  }).join('').replace(/-+/g, '-').trim('-').value().toLowerCase();
};

var lpad = function lpad(string, length) {
  return '' + repeat('_', Math.max(0, length - string.length)) + string;
};

var toSlug = function toSlug(_ref) {
  var field = _ref.field,
      _ref$blackListedSlugs = _ref.blackListedSlugs,
      blackListedSlugs = _ref$blackListedSlugs === undefined ? [] : _ref$blackListedSlugs,
      _ref$generateRandomSl = _ref.generateRandomSlug,
      generateRandomSlug = _ref$generateRandomSl === undefined ? function () {
    return '';
  } : _ref$generateRandomSl,
      _ref$slugify = _ref.slugify,
      slugify = _ref$slugify === undefined ? slugifyUnicode : _ref$slugify,
      _ref$allowedCharacter = _ref.allowedCharacters,
      allowedCharacters = _ref$allowedCharacter === undefined ? [] : _ref$allowedCharacter,
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === undefined ? MIN_SLUG_LENGTH : _ref$minLength;

  var slug = field && slugify(field, allowedCharacters) || generateRandomSlug();

  if (!slug) {
    return '';
  }

  while (includes(blackListedSlugs, slug)) {
    slug = '_' + slug;
  }

  if (slug.length > 0 && slug.length < minLength) {
    slug = lpad(slug, minLength);
  }

  return slug;
};

var truncateWhitelistedCharacter = function truncateWhitelistedCharacter(char) {
  return truncate(char, { omission: '', length: 1 });
};

module.exports = {
  toSlug: toSlug
};